
<template>
    <v-main>
        <AppBar />
        <v-layout fill-height column>
            <v-container flex-fill fluid class="pt-0">
                <div class="fs-16 fw-700 mb-4">보유 쿠폰 <strong class="primary--text ml-2">{{this.couponCount}}</strong></div>
                <div class="no-data" v-if="this.couponCount<=0">현재 보유 중인 쿠폰이 없습니다.</div>
                <div class="d-flex flex-column gap-5" v-else>
					<v-expansion-panel v-for="(item, i) in couponList" :key="i">
						<div :class="item.useYn=== 'N' ? 'coupon' : 'coupon disabled' ">
<!--						<div class="coupon disabled" v-else-if="item.useYn==='Y'">-->
							<div class="fs-18 fw-700 mb-2">
								{{item.cpNm}}
							</div>
							<div class="d-flex justify-space-between fs-14">
								<span class="secondary--text">{{item.cpDscrt}}</span>
								<span class="primary--text" v-if="item.periodLimitYn==='N'">~ {{item.validperiodEndDt}}</span>
								<span class="primary--text" v-else>기간제한없음</span>
							</div>
						</div>
					</v-expansion-panel>
					
<!--                    <div class="coupon disabled">-->
<!--                        <div class="fs-18 fw-700 mb-2">-->
<!--                            쿠폰이름쿠폰이름쿠폰이름쿠폰이름쿠폰이름쿠폰이름-->
<!--                        </div>-->
<!--                        <div class="d-flex justify-space-between fs-14">-->
<!--                            <span class="secondary&#45;&#45;text">대상 조건</span>-->
<!--                            <span class="primary&#45;&#45;text">~ 21.05.20</span>-->
<!--                        </div>-->
<!--                    </div>-->
                </div>
            </v-container>
        </v-layout>
    </v-main>

</template>

<script>
import store from "@/store";

export default {

	data: () => ({
		couponList :[]
		,couponCount:0
	}),
	created() {
		this.getCouponList();
	}
	,methods : {
		async getCouponList () {
			await store.dispatch('getCoupons', this.$_payload({'userKey': store.getters.userKey}))
				.then(res => {
					if (res.success) {
						if(res.data.length > 0) {
							this.couponList = res.data;
							this.couponCount = res.data.length;
						}
						
					} else {
						this.couponList = [];
					}

				}).catch(error => {
					console.log(error);
					this.couponList = [];
				}).finally(() => {
				});
		}
	}
	
}
</script>

<style lang="scss" scoped>
.no-data {
    font-size: 16px;
    color: #9A9A9A;
}
.coupon {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 20px 16px;
    border-radius: 10px;
    box-shadow: 0 3px 10px rgba(0,0,0,0.11);
    min-height: 124px;
    cursor: pointer;
    &.disabled {
        box-shadow: none;
        background: #E6E8EA;
        > div {
            color: $sub-title !important;
            span {
                color: $sub-title !important;
            }
        }
    }
}
</style>